export default __webpack_public_path__ + "static/media/calendar.88a16568.png";